var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestination2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.001 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #de6c59;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3346",
    "data-name": "Group 3346",
    transform: "translate(-2 -147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12",
    "data-name": "Subtraction 12",
    className: "cls-1",
    d: "M-3185,6647h0l-5.361-5.285-.585-.581a7.763,7.763,0,0,1-2.052-5.263,7.945,7.945,0,0,1,8-7.871,7.945,7.945,0,0,1,8,7.871,7.765,7.765,0,0,1-2.053,5.263l-.589.581L-3185,6647Zm0-14a3,3,0,0,0-3,3,3,3,0,0,0,3,3,3,3,0,0,0,3-3A3,3,0,0,0-3185,6633Z",
    transform: "translate(3195.001 -6481)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination2);
export default __webpack_public_path__ + "static/media/destination2.43fe7cf23729e2810ad0be7c9bc47305.svg";
export { ForwardRef as ReactComponent };